import { Tag } from './Tag'
import { filterChips } from '../utils/filterChips'

interface FilterChipsRowProps {
  activeFilter: string
  onSelect: (label: string) => void
  className: string
}

export function FilterChipsRow({ activeFilter, onSelect, className }: FilterChipsRowProps) {
  return (
    <div className={className}>
      {filterChips.map(c => (
        <Tag
          key={c.label}
          variant={c.label === activeFilter ? 'accent' : 'neutral'}
          onClick={() => onSelect(c.label)}
        >
          {c.label}
        </Tag>
      ))}
    </div>
  )
}
